var _g, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokenflask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 248,
    viewBox: "0 0 259 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_22_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06887 212.243C-10.931 171.743 82.0689 71.2427 82.0689 71.2427C82.0689 71.2427 68.0688 19.7427 82.0689 7.74273C96.0689 -4.25727 121.069 -0.757252 131.069 7.74273C141.069 16.2427 131.069 71.2427 131.069 71.2427C131.069 71.2427 160.825 103.832 185.352 139.063L160.5 179.5L179.5 175.5L146.5 204.5L179.5 214L170.971 235.932C110.171 247.829 9.59151 241.007 1.06887 212.243Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_16",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 122,
    width: 85,
    height: 124
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.32 175.561L205.106 124.034L254 202.215L196.742 244.751L205.781 207.197L171.804 202.215L200.61 169.046L182.32 175.561Z",
    fill: "#D9D9D9",
    stroke: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_16)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_22_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.0601 78.8178C90.0601 78.8178 11.3998 190.897 28.73 229.419C46.0603 267.94 238.395 238.846 242.278 200.477C246.16 162.108 138.616 72.2371 138.616 72.2371C138.616 72.2371 141.139 16.3924 130.088 9.31239C119.038 2.23239 93.7938 2.12156 81.5322 15.893C69.2706 29.6645 90.0601 78.8178 90.0601 78.8178Z",
    fill: "#D9D9D9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_22_16",
    x: 0,
    y: 0,
    width: 185.352,
    height: 281.504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 40
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.210461 0 0 0 0 0.51421 0 0 0 0 0.734167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22_16"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_22_16",
    x: 26.2358,
    y: 4.59184,
    width: 216.145,
    height: 282.971,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 40
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.210461 0 0 0 0 0.51421 0 0 0 0 0.734167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22_16"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenflask);
export default __webpack_public_path__ + "static/media/brokenflask.e18978b7ca4e6b2ff61b195047bd162d.svg";
export { ForwardRef as ReactComponent };